export enum RequestOperation {
    READ_ALL = 'operation.entity.request.readall',
    READ_CENTER = 'operation.entity.request.readcenter',
    READ_DEPARTMENT = 'operation.entity.request.readdepartment',
    READ_ONLY_MINE = 'operation.entity.request.readonlymine',
    CREATE = 'operation.entity.request.create',
    LOCK = 'operation.entity.request.lock',
    PETITIONER_CANCEL = 'operation.entity.request.petitioner-cancel',
    PERSONNEL_CANCEL = 'operation.entity.request.personnel-cancel',
    ATTACH = 'operation.entity.request.attach',
    PROCESS = 'operation.entity.request.process',
    PRINT = 'operation.entity.request.print',
    PRINT_REQUEST_AND_LABELS = 'operation.entity.request.printrequestandlabels',
    RETURN = 'operation.entity.request.return'
}
